export default __webpack_public_path__ + "static/media/icon-17.b00f6976.png";